import { createAPI } from "./axios";

export const appsConfigClient = createAPI("https://configs.bussola.farm");
export const productsClient = createAPI("https://mapdata.bussola.farm");
export const adminURL = "https://gestor.bussola.farm";
export const mapboxClient = createAPI("https://api.mapbox.com");
export const addressSearchClient = createAPI("https://photon.komoot.io");
export const geoserverClient = "https://geoserver.bussola.farm/bussola/wms";
